export default "__VITE_ASSET__X_7eyeFf__"